import {Permission} from '@models/permission';
import {UserInterface} from '@app/interfaces/user.interface';
import {School} from '@models/shool';
import {AddressInterface} from '@interfaces/address.interface';
import {Subscription} from '@models/subscription';
import {Attendance} from '@models/attendance';
import {Class} from '@models/class';

export class User implements UserInterface {
  id?: number;
  email?: string;
  name?: string;
  login_name?: string;
  first_name?: string;
  last_name?: string;
  role?: string;
  default_currency?: string;
  phone?: string;
  countryCode?: string;
  emailVerified? = false;
  phoneNumberVerified? = false;
  paymentSettingVerified? = false;
  stripe_email?: string;
  stripe_status?: string;
  notAdmin?: boolean;
  hasProgram?: boolean;
  avatar?: string;
  logo?: string;
  provider_id?: string;
  provider_name?: string;
  registerNotComplete?: boolean;
  permissions?: {
    key?: [Permission]
  } = {};
  family?: User[];
  schools?: [School];
  usedAuthSocial?: boolean|string = false;
  activeSchool?: number;
  parent_id?: number;
  programs_id?: number[];
  classes_id?: number[];
  address?: AddressInterface;
  subscriptions?: Subscription[];
  subscription_id?: number[];
  current_lesson?: Attendance[];
  password?: string;
  password_confirm?: string;
  yearAttendanceFromApi?: Attendance[];
  invited?: boolean;
  classes?: Class[];
  not_read_messages?: number;
  class_name?: string;
  model_id?: number;
  model_name?: string;
  mode?: string;
  model?: string;
  id_payment_method?: number;
  chargeBeforeDelete?: boolean;
  stripeCustomerId?: string;
  stripeAccountId?: string;
  stripePublicKey?: string;
  school_teacher_function?: {
    school_id?: number;
    user_id?: number;
    is_teacher?: boolean;
    effective_is_teacher?: boolean;
    is_global_teacher?: boolean;
    editable?: boolean;
    status?: string;
  };
  card_digits?: string;
  systemSubscriptionStatus?: any;
  birth_date?: string;
  level?: string;
  notes?: string;

  constructor(params?: User) {
    if (params) {
      this.registerNotComplete = params.registerNotComplete;
      this.not_read_messages = params.not_read_messages;
      this.current_lesson = params.current_lesson;
      if (!Array.isArray(this.current_lesson)) {
        this.current_lesson = [];
      }
      this.default_currency = params.default_currency;
      this.email = params.email;
      this.subscriptions = params.subscriptions;
      this.name = params.name;
      this.login_name = params.login_name;
      this.id_payment_method = params.id_payment_method;
      this.first_name = params.first_name;
      this.last_name = params.last_name;
      this.programs_id = params.programs_id;
      this.classes_id = params.classes_id;
      this.role = params.role;
      this.phone = params.phone;
      this.countryCode = params.countryCode;
      this.address = params.address;
      this.notAdmin = params.notAdmin;
      this.parent_id = params.parent_id;
      this.family = params.family;
      this.avatar = params.avatar;
      this.activeSchool = params.activeSchool;
      this.permissions = params.permissions;
      this.schools = params.schools;
      this.hasProgram = params.hasProgram;
      this.id = params.id ? params.id : null;
      this.provider_id = params.provider_id ? params.provider_id : 'null';
      this.provider_name = params.provider_name ? params.provider_name : 'null';
      this.emailVerified = params.emailVerified ? params.emailVerified : false;
      this.phoneNumberVerified = params.phoneNumberVerified ? params.phoneNumberVerified : false;
      this.paymentSettingVerified = params.paymentSettingVerified ? params.paymentSettingVerified : false;
      this.stripe_status = params.stripe_status;
      this.stripe_email = params.stripe_email;
      this.subscription_id = params.subscription_id;
      this.stripeCustomerId = params.stripeCustomerId;
      this.stripeAccountId = params.stripeAccountId;
      this.stripePublicKey = params.stripePublicKey;
      this.school_teacher_function = params.school_teacher_function;
      this.yearAttendanceFromApi = params.yearAttendanceFromApi ? params.yearAttendanceFromApi : [];
      this.card_digits = params.card_digits;
      this.systemSubscriptionStatus = params.systemSubscriptionStatus ? params.systemSubscriptionStatus : [];
      this.birth_date = params.birth_date;
      this.level = params.level;
      this.notes = params.notes;
    }
  }
  //
  // isStudent() {
  //   return this.role === 'student_individual';
  // }
}
